import { render } from "./beneficiary_id_order_by_mitchell_for_management.vue?vue&type=template&id=0eb2477a&scoped=true"
import script from "./beneficiary_id_order_by_mitchell_for_management.vue?vue&type=script&lang=js"
export * from "./beneficiary_id_order_by_mitchell_for_management.vue?vue&type=script&lang=js"

import "./beneficiary_id_order_by_mitchell_for_management.vue?vue&type=style&index=0&id=0eb2477a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb2477a"]])

export default __exports__